/* eslint-disable no-param-reassign */
// this is what @reduxjs/toolkit expects
import {
  createAction,
  createAsyncThunk,
  createReducer,
  createSelector,
} from '@reduxjs/toolkit'
import { redFunnelAPI } from '../api/api'

const initialState = {
  loading: false,
  error: null,
  data: null,
  childrenAge: {},
}

export const fetchAccommodations = createAsyncThunk(
  'accommodationContent/fetch',
  () => redFunnelAPI.getAccommodationsContent(),
)

export const setChildrenAges = createAction(
  'accommodationContent/setChildrenAges',
)

export const accommodationContentReducer = createReducer(
  initialState,
  builder => {
    builder
      .addCase(fetchAccommodations.pending, state => {
        state.loading = true
      })
      .addCase(fetchAccommodations.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
      })
      .addCase(fetchAccommodations.rejected, (state, action) => {
        state.loading = false
        state.error =
          action.error?.response?.data?.['hydra:description'] ||
          action.error?.message ||
          'unable to fetch accommodation details'
      })
      .addCase(setChildrenAges, (state, action) => {
        state.childrenAge = action.payload
      })
  },
)

export const selectAccommodationContentState = state =>
  state.accommodationContent

export const selectAccommodationContent = createSelector(
  selectAccommodationContentState,
  state => state.data,
)
